import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material';

@Injectable()
export class SnackbarService {

    configs: Object;

    constructor(
        private snackbar: MatSnackBar
    ) {
        this.configs = {
            user_actions: {
                duration: 4000,
                horizontalPosition: 'end',
                verticalPosition: 'top'
            }
        }
    }

    openSnackbar(message: string, config: string) { this.snackbar.open(message, '', this.configs[config]) }

}